<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          {{ action }}
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="Customer">
              <b-select
                name="customer"
                :disabled="!isAdd"
                v-model="editObjectName.customer"
                expanded
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in customers"
                  :value="option.id"
                  :key="index"
                  selected
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Country">
              <b-select
                expanded
                required
                name="country"
                v-model="editObjectName.country"
                v-on:input="filterScheme"
                :disabled="!isAdd || isEdit"
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in countries"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>

            <b-field label="Scheme">
              <b-select
                expanded
                required
                name="scheme"
                v-model="editObjectName.scheme"
                v-on:input="filterStream"
                :disabled="!isAdd || isEdit"
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in schemes"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>

            <b-field label="Stream">
              <b-select
                expanded
                required
                name="stream"
                v-model="editObjectName.stream"
                v-on:input="checkValues"
                :disabled="!isAdd"
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in containers"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>

            <b-field label="Username">
              <b-input
                name="username"
                v-model="editObjectName.username"
                required
                :disabled="!isAdd"
              />
            </b-field>

            <b-field label="Password">
              <b-input
                name="password"
                v-model="editObjectName.password"
                required
                :disabled="!isAdd"
              />
            </b-field>
            <b-field label="Website">
              <b-input
                name="website"
                v-model="editObjectName.website"
                :disabled="!isAdd"
              />
            </b-field>
            <b-field label="Additional Information">
              <b-input
                type="textarea"
                name="additional_info"
                v-model="editObjectName.additional_info"
                :disabled="!isAdd"
              />
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot" v-if="isAdd">
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="submit"
          :disabled="disabledSubmitButton"
        >
          Save
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Cancel
        </b-button>
      </footer>
      <footer class="modal-card-foot" v-if="!isAdd">
        <b-button
          v-if="disable && this.action !== 'View'"
          slot="right"
          type="is-danger"
          @click="removeCredentials"
        >
          Delete
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import ClientCredentialsService from "@/services/ClientCredentialsService";
import CountryDataService from "../../services/CountryDataService";
import ContainerDataService from "../../services/ContainerDataService";
import SchemeDataService from "../../services/SchemeDataService";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
export default {
  name: "ClientCredentialsAddView",
  props: {
    action: {
      type: String,
      default: "Inserts"
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    editObjectName: {
      type: Object,
      default: () => {
        return {
          customer: "",
          country: "",
          scheme: "",
          stream: "",
          username: "",
          password: "",
          additional_info: "",
          website: ""
        };
      }
    },
    customerId: {
      type: Number,
      default: -1
    },
    isDelete: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isModalActive: false,
      disabledSubmitButton: false,
      countries: [],
      containers: [],
      schemes: [],
      countryMap: {},
      containerMap: {},
      schemeMap: {},
      customers: [],
      clientCredentialsService: new ClientCredentialsService(),
      containerDataService: new ContainerDataService(),
      countryDataService: new CountryDataService(),
      schemeDataService: new SchemeDataService(),
      customerDataService: new CustomerProfileDataService()
    };
  },
  mounted() {
    this.checkValues();
    this.fetchCountries();
    this.fetchSchemes();
    this.fetchContainers();
    this.fetchCustomerList();
    this.editObjectName.scheme
      ? this.fetchSchemes(this.editObjectName.scheme)
      : "";
  },
  computed: {
    disable() {
      if (this.action == "Edit") {
        return false;
      } else if (this.action == "View") {
        return true;
      } else if (this.action == "Delete") {
        return true;
      }
      return false;
    },
    countryList() {
      return this.$store.state.countryList;
    },
    schemeList() {
      return this.$store.state.schemeList;
    },
    containerList() {
      return this.$store.state.containerList;
    }
  },
  methods: {
    filterScheme(countryId) {
      this.schemeDataService.getByCountry(countryId).subscribe(
        response => {
          this.schemes = response;
        },
        e => {
          console.log(e);
        }
      );
      this.checkValues();
    },
    filterStream(schemeId) {
      this.schemeDataService.get(schemeId).subscribe(
        response => {
          this.containers = response["container"];
          //this.containers = this.containers.filter(e => e.name !== "General");
        },
        e => {
          console.log(e);
        }
      );
      this.checkValues();
    },
    fetchCountries() {
      if (this.countryList.length > 0) {
        this.countries = this.countryList;
        this.countryMap = this.prepareMasterData(this.countries);
      } else {
        this.countryDataService.getAll().subscribe(
          response => {
            this.countries = response;
            this.$store.dispatch("setCountryList", response);
            this.countryMap = this.prepareMasterData(this.countries);
          },
          e => {
            console.log(e);
          }
        );
      }
    },
    fetchSchemes() {
      if (this.schemeList.length > 0) {
        this.schemes = this.schemeList;
        this.schemeMap = this.prepareMasterData(this.schemes);
      } else {
        this.schemeDataService.getAll().subscribe(
          response => {
            this.schemes = response;
            this.$store.dispatch("setSchemeList", response);
            this.schemeMap = this.prepareMasterData(this.schemes);
          },
          e => {
            console.log(e);
          }
        );
      }
    },
    fetchContainers() {
      if (this.containerList.length > 0) {
        this.containers = this.containerList;
        this.containerMap = this.prepareMasterData(this.containers);
      } else {
        this.containerDataService.getAll().subscribe(
          response => {
            this.containers = response;
            this.$store.dispatch("setContainerList", response);
            this.containerMap = this.prepareMasterData(this.containers);
          },
          e => {
            console.log(e);
          }
        );
      }
    },
    fetchCustomerList() {
      this.customerDataService.getCustomerList(this.customerId, true).subscribe(
        customerProfiles => {
          this.customers = customerProfiles;
        },
        e => {
          console.log(e);
        }
      );
    },
    cancel() {
      this.disabledSubmitButton = true;
      this.fetchSchemes();
      this.fetchContainers();
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
    checkValues() {
      if (this.isEdit) {
        this.schemeDataService.get(this.editObjectName.scheme).subscribe(
          response => {
            this.containers = response["container"];
          },
          e => {
            console.log(e);
          }
        );
      }
      if (
        this.editObjectName.scheme &&
        this.editObjectName.stream &&
        this.editObjectName.country
      ) {
        this.disabledSubmitButton = false;
      } else {
        this.disabledSubmitButton = true;
      }
    },
    handleApiError(reason) {
      let errorMessage = "";
      for (const v in reason.response.data) {
        errorMessage += v + ": " + reason.response.data[v] + "<br>";
      }

      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    submit() {
      if (this.action == "Add") {
        this.clientCredentialsService
          .create(this.editObjectName)
          .subscribe(response => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Client credential Created!"
            });
            this.$emit("confirm", response);
          }, this.handleApiError);
      } else if (this.action == "Update") {
        this.clientCredentialsService
          .update(this.editObjectName)
          .subscribe(response => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Client credential Updated!"
            });
            this.$emit("confirm", response);
          }, this.handleApiError);
      }
    },
    removeCredentials() {
      this.clientCredentialsService
        .delete(this.editObjectName.id)
        .subscribe(response => {
          this.$emit("confirm", response);
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Client Credentials Removed!"
          });
        }, this.handleApiError);
    }
  },
  watch: {
    editObjectName() {
      this.checkValues();
    },
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
